import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Gamepad2, Heart, ExternalLink, Mail, MessageCircle } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-800 border-t border-dark-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg flex items-center justify-center">
                <Gamepad2 className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-gaming font-bold text-gradient">
                Aedon Community
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              The newest Aedon community. We provide players with unforgettable experiences 
              with our servers, games and scripts.
            </p>
            <div className="flex space-x-4">
              <motion.a
                href="https://discord.gg/aedonv"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <MessageCircle className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.a>
              <motion.button
                type="button"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Mail className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.button>
              <motion.button
                type="button"
                whileHover={{ scale: 1.1 }}
                className="w-10 h-10 bg-dark-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <ExternalLink className="w-5 h-5 text-gray-400 hover:text-white" />
              </motion.button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/servers" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Servers
                </Link>
              </li>
              <li>
                <Link to="/areas" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Areas
                </Link>
              </li>
              <li>
                <Link to="/sponsors" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Sponsors
                </Link>
              </li>
              <li>
                <Link to="/scripts" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Scripts
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-white font-semibold mb-4">Community</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/guide" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Guide
                </Link>
              </li>
              <li>
                <Link to="/rules" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Rules
                </Link>
              </li>
              <li>
                <a href="https://discord.gg/aedonv" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Discord
                </a>
              </li>
              <li>
                <button type="button" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Support
                </button>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-dark-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Aedon Community. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center space-x-2 mt-4 md:mt-0">
            <span className="text-gray-400 text-sm">Made with</span>
            <Heart className="w-4 h-4 text-red-500 animate-pulse" />
            <span className="text-gray-400 text-sm">by Community Team</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 